import { useEffect, useRef, useState, useCallback } from "react";
import { Box, Button, CircularProgress, Grid } from "@mui/material";
import "./index.css";
import { DataGrid } from "@mui/x-data-grid";
import Navbar from "../../../../posnavbar/Navbar";
import vegSymbol from "../../../../../../assets/images/veg-icon.svg";
import nonVegSymbol from "../../../../../../assets/images/non-veg-icon.svg";
import { useNavigate } from "react-router-dom";
import {
  aggsFilterCategory,
  fetchAddOn,
  getGlobalProductsList,
  getGlobalProductsListV2,
} from "../../../../../../config/Services";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import { PosCustomButton } from "../../../../../../customComponents/PosCustomButton/PosCustomButton";
import CategoryOptionsPage from "../../../all-products/CategoryOptionsPage";
import { UserContext } from "../../../../../../App";
import QuickMenuCard from "./QuickMenuCard";
import alterImg from "../../../../../../assets/images/menu-alter-img.png";
import CommonSearchBar from "../../../../posnavbar/components/commonSearchbar";

export const CreateMenu = () => {
  const showSnackbar = useSnackbar();
  const [selectedCategory, setSelectedCategory] = useState("");
  const [menuItems, setMenuItems] = useState([]);
  const [availableCategories, setAvailableCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [filterTab, setFilterTab] = useState("ALL"); // "ALL" | "NO_INWARD"

  const [createMenusearchText, setCreateMenuSearchText] = useState("");

  const navigate = useNavigate();
  const observerRef = useRef();
  const lastElementRef = useRef();
  const searchDebounceRef = useRef(null);
  const currentPageRef = useRef(1);

  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");

  const handleSearchResults = (results) => {
    setParticularCategoryItems(results);
  };

  //Handling Menu Edit
  const handleRowClick = (item) => {
    navigate("/settings/create-menu-form", {
      state: {
        editData: {
          id: item?.id,
          productId: item?.productId,
          variantId: item?.variantId,
          name: item?.name,
          foodType: item?.foodType,
          salePrice: item?.salePrice,
          shortCode: item?.shortCode,
          imageUrl: item?.imageUrl,
          taxRate: item?.taxRate,
          taxStatus: item?.taxStatus,
          specification: item?.specification,
          unitOfMeasure: item?.unitOfMeasure,
          veganType: item?.vegan,
          categoryLevel1: item?.categoryLevel1,
          categoryLevel1Id: item?.categoryLevel1,
          externalSalesChannels: item?.externalSalesChannels,
          taxType: item?.taxType,
        },
        id: item?.id,
      },
    });
  };

  //Fetching Categories
  const gettingAvailableCategories = () => {
    const payload = {
      page: 1,
      pageSize: 50,
      storeIds: [orgId],
      storeLocations: [locId],
      sortByUpdatedAt: "DESC",
      productTypes: ["MENU"],
    };
    aggsFilterCategory(payload)
      .then((res) => {
        const responseData = res?.data?.data?.data;
        setAvailableCategories(responseData);
      })
      .catch((err) => {
        showSnackbar(err || "Unable to fetch categories", "error");
      });
  };

  //Getting products:
  const gettingProductList = (category = "", page = 1, isLoadMore = false, searchText = "") => {
    if (isLoadMore) {
      setLoadingMore(true);
    } else {
      setLoading(true);
    }

    const payload = {
      page: page,
      pageSize: 18,
      query: searchText || "",
      productTypes: ["MENU"],
      sortByCreatedAt: "DESC",
      storeIds: [orgId],
      storeLocations: [locId],
      productStatus: ["CREATED", "ACTIVE", "IN_ACTIVE"],
      ...(category && {
        appCategories: {
          categoryLevel1: [category],
        },
      }),
    };
    getGlobalProductsListV2(payload)
      .then((resp) => {
        const data = resp?.data?.data?.data;
        const rawData = data?.data || [];
        const totalRecords = data?.totalRecords;

        const transformedData = rawData?.map((item) => ({
          id: item?.id,
          categoryLevel1: item?.appCategories?.categoryLevel1[0] || "",
          categoryLevel2: item?.appCategories?.categoryLevel2[0] || "",
          name: item?.name || "",
          foodType: item?.attributes?.foodType || "",
          salePrice: item?.variants[0]?.externalSalesChannels[0]?.salePrice || "",
          taxRate: item?.taxReference?.taxRate + "%" || "",
          taxType: item?.taxReference?.taxType,
          productTypes: item?.productTypes,
          itemName: item?.variants[0]?.name,
          unitOfMeasure: item?.variants[0]?.weightUnit,
          specification: item?.variants[0]?.weight,
          taxStatus: item?.variants[0]?.taxStatus,
          addOn: item?.variants[0]?.addOn[0],
          vegan: item?.attributes?.vegan || "",
          shortCode: item?.variants[0]?.shortCode || "",
          imageUrl: item?.imageUrls?.front || alterImg,
          externalSalesChannels: item?.variants[0]?.externalSalesChannels || [],
          productId: item?.productId,
          variantId: item?.variants[0]?.variantId,
          status: item?.status,
          noInward: !item?.variants[0]?.inventorySync?.inventoryId,
        }));
        const totalLoadedItems = page * 18;
        setHasMore(totalLoadedItems < totalRecords);
        // setMenuItems(transformedData);
        if (isLoadMore) {
          setMenuItems((prev) => [...prev, ...transformedData]);
        } else {
          setMenuItems(transformedData);
        }
        setLoading(false);
        setLoadingMore(false);
      })
      .catch((err) => {
        showSnackbar(err?.data?.message || "Unable to fetch menu items");
        setLoading(false);
        setLoadingMore(false);
      });
  };

  const refreshProductList = useCallback(() => {
    setMenuItems([]);
    setCurrentPage(1);
    currentPageRef.current = 1;
    setHasMore(true);
    gettingProductList(selectedCategory, 1, false, createMenusearchText);
  }, [selectedCategory, createMenusearchText]);

  // When category changes → fetch accordingly
  useEffect(() => {
    if (observerRef.current) {
      observerRef.current.disconnect();
    }

    setMenuItems([]);
    setCurrentPage(1);
    currentPageRef.current = 1;
    setHasMore(true);

    gettingProductList(selectedCategory, 1, false);
  }, [selectedCategory]);

  // Intersection Observer callback
  // const handleObserver = useCallback(
  //   (entries) => {
  //     const target = entries[0];
  //     if (target.isIntersecting && hasMore && !loading && !loadingMore) {
  //       setCurrentPage((prev) => prev + 1);
  //     }
  //   },
  //   [hasMore, loading, loadingMore]
  // );

  // Setup Intersection Observer
  // useEffect(() => {
  //   const option = {
  //     root: null,
  //     rootMargin: "20px",
  //     threshold: 0,
  //   };

  //   observerRef.current = new IntersectionObserver(handleObserver, option);

  //   if (lastElementRef.current) {
  //     observerRef.current.observe(lastElementRef.current);
  //   }

  //   return () => {
  //     if (observerRef.current) {
  //       observerRef.current.disconnect();
  //     }
  //   };
  // }, [handleObserver]);

  // Load more when currentPage changes
  // useEffect(() => {
  //   if (currentPage > 1) {
  //     console.log("calling getproduct from intersection observer");
  //     gettingProductList(selectedCategory, currentPage, true, createMenusearchText);
  //   }
  // }, [currentPage]);

  // Setup Intersection Observer - consolidated version
  useEffect(() => {
    const handleObserver = (entries) => {
      const target = entries[0];
      if (target.isIntersecting && hasMore && !loading && !loadingMore) {
        // Directly call the API instead of updating state
        // const nextPage = currentPage + 1;
        const nextPage = currentPageRef.current + 1;
        currentPageRef.current = nextPage;
        setCurrentPage(nextPage);
        gettingProductList(selectedCategory, nextPage, true, createMenusearchText);
      }
    };

    const option = {
      // root: null,
      // rootMargin: "20px",
      threshold: 0.1,
    };

    observerRef.current = new IntersectionObserver(handleObserver, option);

    if (lastElementRef.current) {
      observerRef.current.observe(lastElementRef.current);
    }

    return () => {
      if (lastElementRef.current) {
        observerRef.current.unobserve(lastElementRef.current);
      }
    };
  }, [hasMore, loading, loadingMore, selectedCategory, createMenusearchText]);

  // Initial fetch: no category → fetch all products
  useEffect(() => {
    gettingAvailableCategories();
    gettingProductList("", 1);
  }, []);

  // Trigger API when search text changes
  useEffect(() => {
    // Clear previous debounce
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }

    // Set new debounce
    searchDebounceRef.current = setTimeout(() => {
      setMenuItems([]);
      setCurrentPage(1);
      currentPageRef.current = 1;
      setHasMore(true);

      // Clear selected category for global search
      if (selectedCategory) {
        setSelectedCategory("");
      }

      gettingProductList("", 1, false, createMenusearchText);
    }, 500); // 500ms delay

    // Cleanup on unmount or next effect call
    return () => {
      if (searchDebounceRef.current) {
        clearTimeout(searchDebounceRef.current);
      }
    };
  }, [createMenusearchText]);

  return (
    <Navbar
      pageTitle="Quick Menu"
      createMenusearchText={createMenusearchText}
      setCreateMenuSearchText={setCreateMenuSearchText}
    >
      <div className="quickMenuContainer">
        <div className="quickMenuHeaderButtons">
          <div className="quickMenuHeaderButtonsLeft">
            {/* <PosCustomButton title="Menu List" variant="blue-d" radius="4px" p={"8px 10px"} /> */}
            {/* <PosCustomButton
              title="Menu Creation"
              variant="blue-d-transparent"
              radius="4px"
              p={"8px 10px"}
              onClickFunction={() => navigate("/settings/create-menu-form")}
            /> */}
          </div>
          {/* <PosCustomButton
            title="Pause all online orders"
            variant="blue-d"
            radius="4px"
            p={"8px 10px"}
            onClickFunction={() => showSnackbar("Feature is coming soon", "warning")}
          /> */}
          <PosCustomButton
            title="Add Menu Items"
            variant="blue-d"
            radius="4px"
            p={"8px 10px"}
            onClickFunction={() => navigate("/settings/create-menu-form")}
          />
        </div>

        {/* Filter tabs */}
        <div className="quickMenuFilterTabs">
          <button
            className={`quickMenuFilterTab ${filterTab === "ALL" ? "quickMenuFilterTabActive" : ""}`}
            onClick={() => setFilterTab("ALL")}
          >
            All Products
          </button>
          <button
            className={`quickMenuFilterTab quickMenuFilterTabNoInward ${filterTab === "NO_INWARD" ? "quickMenuFilterTabActive quickMenuFilterTabNoInwardActive" : ""}`}
            onClick={() => setFilterTab("NO_INWARD")}
          >
            No Inward Done
            {menuItems?.filter((i) => i?.noInward)?.length > 0 && (
              <span className="quickMenuFilterTabBadge">
                {menuItems?.filter((i) => i?.noInward)?.length}
              </span>
            )}
          </button>
        </div>

        <div className="quickMenuInnerContainer">
          <Grid container spacing={2}>
            <Grid item xs={12} md={2.5}>
              <div className="quickMenuCategoryContainer">
                <CategoryOptionsPage
                  data={availableCategories}
                  backgroundColor={"var(--surface-g0)"}
                  height="calc(100vh - 160px)"
                  selectedCategory={selectedCategory}
                  onCategoryClick={(categoryName) => {
                    setSelectedCategory(categoryName === selectedCategory ? "" : categoryName);
                  }}
                />
              </div>
            </Grid>

            <Grid item xs={12} md={9.5}>
              <div className="quickMenuProductContainer">
                {loading ? (
                  <div className="createMenuProductListLoader">
                    <CircularProgress sx={{ color: "#0860E6" }} size={22} />
                  </div>
                ) : (
                  <div className="quickMenuProductList">
                    {menuItems
                      ?.filter((item) => filterTab === "ALL" || item?.noInward)
                      ?.map((item, idx, arr) => (
                      <div
                        key={idx}
                        className="quickMenuCardWrapper"
                        ref={idx === arr?.length - 1 ? lastElementRef : null}
                      >
                        <QuickMenuCard
                          id={item?.id}
                          image={item?.imageUrl}
                          title={item?.name}
                          price={item?.salePrice}
                          shortCode={item?.shortCode}
                          foodType={item?.foodType}
                          status={item?.status}
                          noInward={item?.noInward}
                          onEdit={() => handleRowClick(item)}
                          onStatusToggle={refreshProductList}
                        />
                      </div>
                    ))}
                    {loadingMore && (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          padding: "20px",
                        }}
                      >
                        <CircularProgress sx={{ color: "#0860E6" }} size={22} />
                      </div>
                    )}
                    {filterTab === "NO_INWARD" &&
                      !loading &&
                      menuItems?.filter((i) => i?.noInward)?.length === 0 && (
                        <div className="noInwardEmptyState">
                          <p className="noInwardEmptyStateTitle">No issues found</p>
                          <p className="noInwardEmptyStateDesc">
                            All loaded products have an inward record. Scroll down to load more.
                          </p>
                        </div>
                      )}
                    {!hasMore && menuItems?.filter((i) => filterTab === "ALL" || i?.noInward)?.length > 0 && (
                      <div className="noMoreItemsText">No more items to load</div>
                    )}
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </Navbar>
  );
};
